
import Seo from '../../components/Seo';
const DOTS = (
  <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
);

const CHK = (
  <svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
);

export default function ProjectTrackingPage() {
  
  return (
    <>
      <Seo title="Project Tracking — Project Time & Team Allocation | TeamGrid™" description="Real hours land on real projects automatically. Track time distribution, budget burn and team allocation from live activity, with no timesheets to chase." />
      <header className="fh">
        <div className="fh-grid">
          <div className="fh-copy">
            <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Project Intelligence <span className="arr">›</span></span>
            <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '26px', maxWidth: '760px'}}>Projects that<br /><span style={{color: '#a9aab3'}}>report themselves</span></h1>
            <p style={{maxWidth: '620px', marginBottom: '26px', fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)'}}>Real hours land on real projects automatically. Progress comes from activity, not from a status meeting where everyone says 80%.</p>
            <ul className="hero-checks">
              <li>{CHK}<span><b>Project dashboard.</b> Every project with its time and team metrics.</span></li>
              <li>{CHK}<span><b>Time distribution.</b> How hours actually spread across the portfolio.</span></li>
              <li>{CHK}<span><b>Team allocation.</b> Who is working on what, right now.</span></li>
            </ul>
            <div className="hero-cta-row">
              <a className="btn-primary" href="/register">Track projects free</a>
              <span className="hero-cta-note">7-day free trial.<br />No credit card.</span>
            </div>
          </div>
          <div className="fh-vis">
            <div className="frame">
              <div className="frame-h">{DOTS}PROJECT HOURS LOGGED — LAST 14 DAYS</div>
              <div className="hbars" style={{height: '104px', padding: '16px 18px 14px'}}>
                <i style={{height: '72%'}}></i><i style={{height: '88%'}}></i><i style={{height: '80%'}}></i><i style={{height: '94%'}}></i><i style={{height: '67%'}}></i><i className="id" style={{height: '12%'}}></i><i className="id" style={{height: '8%'}}></i><i style={{height: '76%'}}></i><i style={{height: '91%'}}></i><i style={{height: '84%'}}></i><i style={{height: '97%'}}></i><i style={{height: '70%'}}></i><i className="id" style={{height: '14%'}}></i><i className="id" style={{height: '9%'}}></i>
              </div>
            </div>
            <div className="frame" style={{marginTop: '14px'}}>
              <div className="frame-h">{DOTS}COMPLETION VS PLAN — 24 PROJECTS</div>
              <div className="applist" style={{padding: '14px 18px 16px'}}>
                <span className="ap"><i style={{background: '#34A851'}}></i>Seller7<span className="bar"><b style={{width: '82%', background: '#34A851'}}></b></span><span className="pc">82%</span></span>
                <span className="ap"><i style={{background: '#469FD8'}}></i>E-commerce<span className="bar"><b style={{width: '64%', background: '#469FD8'}}></b></span><span className="pc">64%</span></span>
                <span className="ap"><i style={{background: '#6C59A6'}}></i>Branding<span className="bar"><b style={{width: '47%', background: '#6C59A6'}}></b></span><span className="pc">47%</span></span>
                <span className="ap"><i style={{background: '#F2673A'}}></i>EzPrep<span className="bar"><b style={{width: '31%', background: '#F2673A'}}></b></span><span className="pc">31%</span></span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <h2 className="sect-h2">Complete project<br /><span className="dim">visibility</span></h2>
          <p className="sect-sub">See which projects are on track and which need attention, before the deadline tells you.</p>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#2DBDB8'}}>PROJECT DASHBOARD</span>
              <h3>Every project on one screen, always current</h3>
              <p className="fd">Time and team metrics per project, updated from live activity. Seller7 has run 50h 29m across 19 people this month, and you knew it without asking anyone.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Hours and headcount per project, live</li>
                <li><span className="sarr">→</span>Active and at-risk projects marked clearly</li>
                <li><span className="sarr">→</span>No status call needed to get the number</li>
              </ul>
            </div>
            <div className="frame">
              <div className="frame-h">{DOTS}ALL PROJECTS — 24 PROJECTS · 24 ACTIVE</div>
              <div className="applist" style={{padding: '16px 18px'}}>
                <span className="ap"><i style={{background: '#34A851'}}></i>Seller7<span className="bar"><b style={{width: '100%', background: '#34A851'}}></b></span><span className="pc">50h</span></span>
                <span className="ap"><i style={{background: '#34A851'}}></i>E-commerce<span className="bar"><b style={{width: '60%', background: '#469FD8'}}></b></span><span className="pc">30h</span></span>
                <span className="ap"><i style={{background: '#34A851'}}></i>Branding<span className="bar"><b style={{width: '26%', background: '#6C59A6'}}></b></span><span className="pc">13h</span></span>
                <span className="ap"><i style={{background: '#34A851'}}></i>General<span className="bar"><b style={{width: '24%', background: '#2DBDB8'}}></b></span><span className="pc">12h</span></span>
                <span className="ap"><i style={{background: '#F2673A'}}></i>Designing<span className="bar"><b style={{width: '13%', background: '#F2A73A'}}></b></span><span className="pc">6h</span></span>
                <span className="ap"><i style={{background: '#F2673A'}}></i>EzPrep<span className="bar"><b style={{width: '9%', background: '#F2673A'}}></b></span><span className="pc">4h</span></span>
              </div>
            </div>
          </div>

          <div className="frow rev">
            <div className="frame">
              <div className="frame-h">{DOTS}TIME DISTRIBUTION — THIS MONTH</div>
              <div className="applist" style={{padding: '16px 18px'}}>
                <span className="ap">Seller7<span className="bar"><b style={{width: '43%', background: '#34A851'}}></b></span><span className="pc">43%</span></span>
                <span className="ap">E-commerce<span className="bar"><b style={{width: '26%', background: '#469FD8'}}></b></span><span className="pc">26%</span></span>
                <span className="ap">Branding<span className="bar"><b style={{width: '11%', background: '#6C59A6'}}></b></span><span className="pc">11%</span></span>
                <span className="ap">General<span className="bar"><b style={{width: '10%', background: '#2DBDB8'}}></b></span><span className="pc">10%</span></span>
                <span className="ap">Everything else<span className="bar"><b style={{width: '10%', background: '#dfe3e9'}}></b></span><span className="pc">10%</span></span>
              </div>
            </div>
            <div className="fr-copy">
              <span className="fl" style={{color: '#469FD8'}}>TIME DISTRIBUTION</span>
              <h3>Where the month really went</h3>
              <p className="fd">Usage maps to project workflows automatically, so you can see how hours split across the portfolio and how each budget is tracking while there is still time to move people.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Hours mapped to projects without manual entry</li>
                <li><span className="sarr">→</span>Budget versus actuals kept current</li>
                <li><span className="sarr">→</span>Slippage flagged from live burn, early</li>
              </ul>
            </div>
          </div>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#8B75D7'}}>TEAM ALLOCATION</span>
              <h3>Who is on what, without asking</h3>
              <p className="fd">Nineteen people on Seller7, two on EzPrep. Allocation is visible per project and per person, so overload and idle capacity both show up before someone burns out or a deadline slips.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Members assigned and actually contributing</li>
                <li><span className="sarr">→</span>Overloaded and under-used people both surface</li>
                <li><span className="sarr">→</span>Rebalance from data, not from volume of complaint</li>
              </ul>
            </div>
            <div className="frame sumcard">
              <div className="sc-t">ALLOCATION FLAG — EZPREP</div>
              <p style={{fontSize: '13.5px', lineHeight: '20px'}}>Only <b>2 members</b> and <b>4h 33m</b> logged this month against a <b>60%</b> completion target. Burn is behind plan. Seller7 is carrying <b>19 of 32</b> people — the easiest fix is one reallocation, this week.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <div className="roi-cards" style={{marginTop: '0'}}>
            <div className="roi-card"><div className="rl">PROJECTS</div><div className="rv">24</div><p>Tracked in the sample workspace, all 24 of them currently active.</p></div>
            <div className="roi-card"><div className="rl">BUSIEST PROJECT</div><div className="rv">50h 29m</div><p>Seller7, across 19 members — visible without a single status call.</p></div>
            <div className="roi-card"><div className="rl">MANUAL ENTRY</div><div className="rv">0</div><p>No timesheets. Hours attach to projects as the work happens.</p></div>
            <div className="roi-card"><div className="rl">SCREENSHOTS</div><div className="rv">0</div><p>Ever. Patterns, not people — measurement with dignity.</p></div>
          </div>
        </div>
      </section>

      <div className="container"><p className="roi-note" style={{margin: '0 0 4px'}}>*Sample workspace data shown. Your numbers come from your own projects.</p></div>
      <div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/monitoring">Monitoring →</a><a href="/features/team-management">Team Management →</a></div></div>

      <section className="sect" style={{padding: '8px 0 24px'}}>
        <div className="container">
          <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
          <div className="faq">
            <details><summary>Can TeamGrid track time against specific projects?</summary><p>Yes. Usage maps to project workflows, so you can see exactly where time is going per project and how each budget is tracking against it.</p></details>
            <details><summary>Do people have to log hours manually?</summary><p>No. Hours are captured from real activity and attached to projects automatically, which removes timesheet chasing and makes billable time more accurate.</p></details>
            <details><summary>How do I know a project is slipping?</summary><p>Live burn is compared against the plan, so a project falling behind shows up in the dashboard while there is still room to reallocate people.</p></details>
          </div>
        </div>
      </section>

      <section className="final" style={{paddingTop: '48px'}}>
        <div className="container-wide">
          <div className="final-band" style={{paddingBottom: '88px'}}>
            <h2>Know where the hours<br />are really going</h2>
            <a className="btn-white" href="/register">Get started FREE</a>
          </div>
        </div>
      </section>
    </>
  );
}
